export default __webpack_public_path__ + "8d8d09414874423fe60e0e3bafb42742.svg";